var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.3@core-js/library/modules/_cof.js
// module id = 34
// module chunks = 1